import Select from 'react-select';
import './style.css';
import { useTranslation } from 'react-i18next';
import { Block, Inline } from '../../../crRender';

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#fe4d22'
      : state.isFocused
        ? 'rgba(19, 84, 206, 0.1)'
        : 'white',
    color: state.isSelected ? '#fff' : '#333',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  }),

  multiValue: (provided) => ({
    ...provided,
    backgroundColor: 'rgba(34, 93, 254, 0.1)',
    padding: '0px 10px',
    borderRadius: '12px',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#345dfe',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#345dfe',
    ':hover': {
      color: 'black',
    },
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 8910000565632356,
  }),
};

const MultiSelect = ({ label, viewLabel = true, sOptions, setSOptions, isRequired = true, isError, setInputValue, options = [], isClearable = true, className = "col-md-6", isMulti = true, isDisabled = false, isRender }) => {

  const { t } = useTranslation()


  return (
    <Block isRender={isRender} className={`form-group ${className}  ${isError ? "field-required" : ""}  multiSelect `} >
      <Block isRender={label && viewLabel} className={"col-sm-12 default-label"} >
        {t(label)}
        <Inline isRender={isRequired} className={"required"}>*</Inline>
      </Block>

      <Select
        className={`multi-select `}
        options={options}
        styles={customStyles}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        isMulti={isMulti}
        isSearchable
        onChange={setSOptions}
        onInputChange={(e) => setInputValue?.(e)}
        value={sOptions}
        placeholder={`${t("select")} ${t(label)}`}
        isClearable={isClearable}
        isDisabled={isDisabled}
      />
    </Block>

  )

}
export default MultiSelect;